// const URL = "http://localhost:3333/"
const URL = "https://social-media-aiveekei.herokuapp.com/"

export default URL